import { createTheme } from "@material-ui/core/styles";

export const temaAplicacao = createTheme({
  palette: {
    primary: {
      main: "#D4BFF9",
      contrastText: "#fafafa",
    },
    secondary: {
      main: "#D4BFF9",
      contrastText: "#fff",
    },
    warning: {
      main: "#f7c600",
      contrastText: "#131313",
    },
    error: {
      main: "#c63100",
      contrastText: "#fff",
    },
  },
  overrides: {
    MuiTableCell: {
      root: {
        padding: "4px 8px",
        fontSize: 13,
      },
      head: {
        fontWeight: 600,
        backgroundColor: "rgba(0,0,0,0.0125)",
      },
    },
    MuiCardHeader: {
      root: {
        paddingBottom: 0,
      },
      title: {
        fontSize: 18,
      },
      subheader: {
        fontSize: 14,
      },
    },
    MuiCardContent: {
      root: {
        "&:last-child": {
          paddingBottom: 0,
        },
      },
    },
    MuiTypography: {
      h1: {
        fontSize: "2.4rem",
      },
      h2: {
        fontSize: "2.1rem",
      },
      h3: {
        fontSize: "1.5rem",
      },
      h4: {
        fontSize: "1.25rem",
      },
      h5: {
        fontSize: "1.125rem",
      },
      h6: {
        fontWeight: 600,
        fontSize: "0.875rem",
      },
    },
  },
});

export default temaAplicacao;
